export default __webpack_public_path__ + "static/home-background-lg-357906eec9c4be13ce0a42ce167f11a2.jpg";